
import React from 'react';

const IntroductionCard = () => {
  return (
    <div className="mb-12 sm:mb-16 md:mb-20">
      <div className="max-w-5xl mx-auto">
        <div className="relative">
          {/* Background decoration */}
          <div className="absolute -inset-2 sm:-inset-4 bg-gradient-to-br from-[#003a70]/5 via-[#FEE6D8]/10 to-[#003a70]/5 rounded-2xl sm:rounded-3xl blur-xl"></div>
          
          {/* Main card */}
          <div className="relative bg-white border border-[#FEE6D8]/30 rounded-xl sm:rounded-2xl shadow-xl overflow-hidden">
            {/* Header */}
            <div className="bg-gradient-to-r from-[#003a70] to-[#003a70]/90 px-4 py-4 sm:px-6 sm:py-5 md:px-8 md:py-6">
              <div className="text-center">
                <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-1 sm:mb-2">👋 Hey there, Fellow Agency Owner,</h2>
                <p className="text-base sm:text-lg md:text-xl text-[#FEE6D8] font-medium">
                  <span className="font-semibold">Dave Calafiore</span> here, co-founder of AskSpot.
                </p>
              </div>
            </div>
            
            {/* Content */}
            <div className="px-4 py-6 sm:px-6 sm:py-8 md:px-8 md:py-10">
              <div className="prose prose-lg max-w-none">
                <div className="mb-6 sm:mb-8">
                  <p className="font-semibold text-gray-800 mb-3 sm:mb-4 text-lg sm:text-xl">
                    Let me ask you something candidly...
                  </p>
                  
                  <div className="bg-[#FEE6D8]/20 border-l-4 border-[#003a70] rounded-r-lg p-4 sm:p-6 mb-4 sm:mb-6">
                    <p className="text-lg sm:text-xl md:text-2xl font-bold text-[#003a70] italic">
                      Does your day-to-day often feel like you're pushing the same boulder uphill?
                    </p>
                  </div>
                </div>
                
                <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-gray-700 leading-relaxed">
                  <p>
                    You're skilled, right? You deliver quality digital marketing work. You can transform a business's online presence.
                  </p>
                  
                  <p>
                    But when it comes to consistently bringing in new clients... to confidently showcasing new opportunities... <span className="font-semibold text-[#003a70] bg-[#FEE6D8]/30 px-1 rounded">does that inner voice of doubt or procrastination start to get loud?</span>
                  </p>
                  
                  <div className="bg-gradient-to-r from-[#003a70]/5 to-transparent border border-[#003a70]/20 rounded-xl p-4 sm:p-6">
                    <p className="font-semibold text-[#003a70] text-lg sm:text-xl">
                      If that sounds even a little familiar, know this: you're in good company.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroductionCard;
